import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzTooltipInjectorModule, DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzPictogramsModule, dzRisk } from '@blk/daisy/core/pictograms';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { AnimationsModule, DomModule } from '@ddt-web/dom';
import { ActionsDrawerModule } from '@ddt-web/elements';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';
import { NotificationsModule } from '@ddt-web/notifications';
import { faChartPie, faLock, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BrowsingActionsDrawerComponent } from '../components/browsing-actions-drawer/browsing-actions-drawer.component';
import { FamilyFooterModule } from '../family-footer/family-footer.module';
import { ModelsBrowseFilterPipe } from '../pipes/models-browse-filter.pipe';
import { RiskProfileIndicatorModule } from '../risk-profile-indicator/risk-profile-indicator.module';
import { FamiliesContainerSkeletonComponent } from './families-container-skeleton/families-container-skeleton.component';
import { FamilyListComponent } from './family-list';
import { ModelListComponent } from './model-list-container/model-list';
import { ModelListContainerComponent } from './model-list-container/model-list-container.component';
import { ModelListEmptyContainerComponent } from './model-list-container/model-list-empty-container/model-list-empty-container.component';
import { ModelListSkeletonComponent } from './model-list-container/model-list/model-list-skeleton/model-list-skeleton.component';

@NgModule({
	declarations: [
		FamiliesContainerSkeletonComponent,
		FamilyListComponent,
		ModelListContainerComponent,
		BrowsingActionsDrawerComponent,
		ModelListComponent,
		ModelListSkeletonComponent,
		ModelsBrowseFilterPipe,
		ModelListEmptyContainerComponent
	],
	imports: [
		CommonModule,
		GenericPipesModule,
		AnalyticsModule,
		AnimationsModule,
		CoreModule,
		CwpNgFrameworkModule,
		NgxSkeletonLoaderModule,
		ActionsDrawerModule,
		SharedModule,
		DataServiceModule,
		RouterModule,
		DzCheckboxModule,
		DzTooltipInjectorModule,
		DzTooltipModule,
		DzButtonModule,
		DzIconModule.withIcons(faPlus, faMinus, faLock, faChartPie),
		DzPictogramsModule.register(dzRisk),
		RiskProfileIndicatorModule,
		FamilyFooterModule,
		DisclosureModule,
		GenericDirectivesModule,
		DomModule
	],
	exports: [
		FamiliesContainerSkeletonComponent,
		FamilyListComponent,
		BrowsingActionsDrawerComponent,
		ModelListContainerComponent,
		ModelListEmptyContainerComponent,
		NotificationsModule,
		GenericDirectivesModule,
		DomModule
	]
})
export class FamiliesModule { }
